export enum Path {
  Signup = "/",
  Login = "/login",
  ChangeEmail = "/change-email",
  ResetPassword = "/reset-password",
  Logout = "/logout",
  SSOLogin = "/sso-login",
}
